import type { SVGProps } from 'react';
const SvgViewList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_list_svg__a)">
      <path
        fill="currentColor"
        d="M4 14h4v-4H4v4Zm0 5h4v-4H4v4ZM4 9h4V5H4v4Zm5 5h12v-4H9v4Zm0 5h12v-4H9v4ZM9 5v4h12V5H9Z"
      />
    </g>
    <defs>
      <clipPath id="view_list_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewList;
